import cx from 'classnames';
import { Navigate, useNavigate } from 'react-router-dom';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	DataBoxFolderType,
	DataBoxListStatesType,
	DataBoxSearchFormProvider,
	useDataBoxesContext,
	useDataBoxMessageListContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Icon } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import {
	DataBoxStorageUsage,
	DataBoxStorageUsageVariant,
} from '../DataBoxes/DataBoxStorageUsage';
import { DataBoxMessageListConfirmModal } from './DataBoxMessageListConfirmModal';
import { DataBoxMessageListFooter } from './DataBoxMessageListFooter';
import { DataBoxMessageListHeader } from './DataBoxMessageListHeader';
import { DataBoxMessageListMain } from './DataBoxMessageListMain';

export const DataBoxMessageListPage = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const navigate = useNavigate();

	const { dataBoxId, disableNewMessageButton } = useDataBoxesContext();

	const {
		listState,
		messagesFilter: { folderType, setQuery },
		messagesSelect: { showCheckboxes },
		isMessageListHidden,
	} = useDataBoxMessageListContext();

	const { extraConfig } = useExtraConfigContext();

	// Navigate back to Recieved when accessing Archive on PP, where Archive is disabled.
	if (
		!extraConfig.pageRoutes.databoxConfig.displayArchiveFolder &&
		folderType === DataBoxFolderType.Archived
	) {
		return (
			<Navigate
				to={pageRouteResolver('datove-schranky.schranka', {
					dataBoxId,
					folderType: DataBoxFolderType.Received,
				})}
				replace
			/>
		);
	}

	if (
		!Object.values(DataBoxFolderType).includes(folderType as DataBoxFolderType)
	) {
		return <div>{tn('zpravy.chyba')}</div>;
	}

	return (
		<section
			className={cx(
				'flex-col w-full h-full bg-(--background-block-primary) [ ds:flex ds:grow-0 ds:shrink-0 ds:w-[400px] ds:rounded-3xl ds:overflow-hidden ]',
				isMessageListHidden ? 'is-hidden' : 'is-visible'
			)}>
			<DataBoxStorageUsage variant={DataBoxStorageUsageVariant.Accordeon} />
			<DataBoxSearchFormProvider setQuery={setQuery}>
				<DataBoxMessageListHeader />
				<DataBoxMessageListMain />
			</DataBoxSearchFormProvider>
			{showCheckboxes && <DataBoxMessageListFooter />}
			<DataBoxMessageListConfirmModal />

			{listState === DataBoxListStatesType.List && !isMessageListHidden && (
				<Button
					onClick={() =>
						navigate(
							pageRouteResolver('datove-schranky.schranka.nova-zprava', {
								dataBoxId,
								folderType,
							})
						)
					}
					color="primary"
					type="solid"
					size="l"
					className="ds-float-button fixed bottom-6 right-5 visible z-50 [ xl:hidden! ]"
					isDisabled={disableNewMessageButton}
					aria-label={tn('zpravy.wcag.nova-zprava')}
					iconStart={
						<Icon
							name="plus-circle"
							type="templates"
						/>
					}>
					{tn('zpravy.nova-zprava')}
				</Button>
			)}
		</section>
	);
};
